import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const UnnamedDriverExcess = (props) => {
  return (
    <FormGroup controlId="unnamedDriverExcess">
      <Col componentClass={ControlLabel} sm={5}>
        Unnamed Driver Excess (HKD)
      </Col>
      <Col sm={7}>
          <FormControl
            type="text"
            autoComplete="off"
            value={props.unnamedDriverExcess}
            maxLength="60"
            onChange={props.handleChangeUnnamedDriverExcess} />
      </Col>
    </FormGroup>
  )
}

UnnamedDriverExcess.propTypes = {
  unnamedDriverExcess: PropTypes.string,
  handleChangeUnnamedDriverExcess: PropTypes.func
};

export default UnnamedDriverExcess;



// WEBPACK FOOTER //
// ./src/app/components/coverNoteCVComponent/unnamedDriverExcess/UnnamedDriverExcess.js